import Vue from 'vue'
import { isEqual } from 'lodash'
import { formatDatesForRequest } from '@/utils'

import app from '@/main'

const visitsModule = {
  namespaced: true,
  state: {
    first: {
      request_params: {
        start: null,
        end: null,
        source: 'all',
        condition: 'visits'
      },
      data: null,
      total_per_period: null,
      loading: false
    },
    second: {
      request_params: {
        start: null,
        end: null,
        source: 'all',
        condition: 'visits'
      },
      data: null,
      total_per_period: null,
      loading: false
    },
    compare_flag: false,
    active_period: 'first'
  },

  mutations: {
    setLoading: (state, { loading, period_type }) => (state[period_type].loading = loading),
    setRequestParams: (state, { params, period_type }) =>
      (state[period_type].request_params = params),
    setData: (state, { data, period_type }) => (state[period_type].data = data),
    setTotalPerPeriod: (state, { total_per_period, period_type }) => (state[period_type].total_per_period = total_per_period),
    setCompareFlag: (state, status) => (state.compare_flag = status),
    setActivePeriod: (state, period) => (state.active_period = period)
  },

  actions: {
    FETCH_VISITS_ANALYTICS: async ({ rootGetters }, payload) => {
      const params = {
        start: formatDatesForRequest(payload.start),
        end: formatDatesForRequest(payload.end),
        source: payload.source,
        condition: payload.condition
      }

      try {
        const response = await Vue.http.get(`${rootGetters.getBackendUrl}/analytics/visits`, {
          params,
          headers: rootGetters.getAllResponseHeaders
        })

        if (response.status === 200) {
          return response.body
        }
      } catch (e) {
        app.$raven.captureException(
          new Error('Error - store/analytics/visits, FETCH_VISITS_ANALYTICS'),
          {
            extra: e,
            tags: {
              component: 'store/analytics/visits',
              method: 'FETCH_VISITS_ANALYTICS'
            }
          }
        )
      }
    },
    GET_VISITS_ANALYTICS: async ({ dispatch, commit, state, rootState }, payload) => {
      const { start, end, source, condition, period_type } = payload
      const params = { start, end, source, condition }

      if (
        rootState.desktop.visits.data &&
        isEqual(params, rootState.desktop.visits.request_params)
      ) {
        commit('setData', { data: rootState.desktop.visits.data, period_type })
        commit('setTotalPerPeriod', { total_per_period: rootState.desktop.visits.total_per_period, period_type })
        commit('setRequestParams', {
          params: rootState.desktop.visits.request_params,
          period_type
        })
        commit('setLoading', { loading: false, period_type })
        return
      }

      if (state[period_type].data && isEqual(params, state[period_type].request_params)) return

      try {
        commit('setLoading', { loading: true, period_type })
        const response = await dispatch('FETCH_VISITS_ANALYTICS', params)
        commit('setData', { data: response.visits, period_type })
        commit('setTotalPerPeriod', { total_per_period: response.total_per_period, period_type })
        commit('setRequestParams', { params, period_type })
        commit('setLoading', { loading: false, period_type })
      } catch (e) {
        app.$raven.captureException(
          new Error('Error - store/analytics/visits, GET_VISITS_ANALYTICS'),
          {
            extra: e,
            tags: {
              component: 'store/analytics/visits',
              method: 'GET_VISITS_ANALYTICS'
            }
          }
        )
        app.$message('danger', e.statusText || 'Error')
      }
    }
  }
}

export default visitsModule



// WEBPACK FOOTER //
// ./src/store/modules/analytics/modules/visits.js